// Helper para obtener la IP publica del navegador (usuario final).
// Se cachea en localStorage para no consultar en cada request.

let cachedIp = null;

export async function getClientIp() {
  // 1) Cache en memoria
  if (cachedIp) return cachedIp;

  // 2) Cache en localStorage
  const stored = localStorage.getItem('client_ip');
  if (stored) {
    cachedIp = stored;
    return stored;
  }

  // 3) Consultar servicio publico
  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    if (data && data.ip) {
      cachedIp = data.ip;
      localStorage.setItem('client_ip', data.ip);
      return data.ip;
    }
  } catch (e) {
    console.warn('No se pudo obtener la IP del cliente:', e);
  }
  return '';
}
